import {
  type CountryCode,
  getCountries,
  getCountryCallingCode,
} from 'libphonenumber-js';

export interface CountryOption {
  code: CountryCode;
  name: string;
  dial: string;
  flag: string;
}

const countryDisplay = new Intl.DisplayNames(['en'], { type: 'region' });

// Regional indicator symbols: each ASCII letter A–Z maps to
// U+1F1E6–U+1F1FF, so a two-letter ISO code becomes its flag emoji.
function flagFromCountry(code: CountryCode): string {
  const base = 0x1f1e6;
  const offsetA = 'A'.charCodeAt(0);
  return String.fromCodePoint(
    code.charCodeAt(0) - offsetA + base,
    code.charCodeAt(1) - offsetA + base
  );
}

export const COUNTRY_OPTIONS: CountryOption[] = getCountries()
  .map(code => ({
    code,
    name: countryDisplay.of(code) ?? code,
    dial: `+${getCountryCallingCode(code)}`,
    flag: flagFromCountry(code),
  }))
  .sort((a, b) => a.name.localeCompare(b.name));
